import * as currencies from '../../i18n/currencies';
import * as messages from '../../i18n/messages';
import { LocaleConfig } from '../../models';

export const DEFAULT_LOCALE_CONFIG: LocaleConfig = {
  messages: messages,
  currencies,
  languagesFallbacks: {}
};
